import * as R from 'ramda'
import { Menus } from '../actions/index'

const DEFAULT_STATE = {
  main: [],
  footer: [],
}

const reducer = (state = DEFAULT_STATE, action) =>
  R.cond([
    [
      R.equals(Menus.TYPE.receive_main_menu),
      () => R.merge(state, { main: action.payload }),
    ],
    [
      R.equals(Menus.TYPE.receive_footer_menu),
      () => R.merge(state, { footer: action.payload }),
    ],
    [R.T, R.always(state)],
  ])(action.type)

export default reducer
